import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";

@Component({
  selector: "app-asociar-tx",
  templateUrl: "./asociar-tx.component.html",
  styleUrls: ["./asociar-tx.component.scss"],
})
export class AsociarTxComponent extends SuperClassComponent implements OnInit {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef,
    private router: Router
  ) {
    super(panelService, cdRef);
  }

  ngOnInit(): void {
    const tax = localStorage.getItem("Taxonomia");
    if (tax !== "1") {
      this.router.navigate(["/portada"]);
      return;
    }
    super.ngOnInit();
  }
}
